import { Mark, mergeAttributes } from '@tiptap/core';

export interface BackgroundColorOptions {
  types: string[];
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    setBackgroundColor: {
      /**
       * Set the background color
       */
      setBackgroundColor: (color: string) => ReturnType;
      /**
       * Unset the background color
       */
      unsetBackgroundColor: () => ReturnType;
    };
  }
}

export const BackgroundColor = Mark.create<BackgroundColorOptions>({
  name: 'backgroundColor',

  addOptions() {
    return {
      types: ['textStyle']
    };
  },

  addAttributes() {
    return {
      backgroundColor: {
        default: null,
        parseHTML: element => element.style.backgroundColor,
        renderHTML: attributes => {
          if (!attributes.backgroundColor) {
            return {};
          }
          return { style: `background-color: ${attributes.backgroundColor}` };
        }
      }
    };
  },

  parseHTML() {
    return [
      {
        style: 'background-color'
      }
    ];
  },

  renderHTML({ mark, HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes, { style: `background-color: ${mark.attrs.backgroundColor}` }), 0];
  },

  addCommands() {
    return {
      setBackgroundColor: color => ({ chain }) => {
        return chain().setMark(this.name, { backgroundColor: color }).run();
      },
      unsetBackgroundColor: () => ({ chain }) => {
        return chain().unsetMark(this.name).run();
      }
    };
  }
});